import { CommonModule } from '@angular/common';
import { Component, Input, NgModule } from '@angular/core';

@Component({
    selector: 'app-bx-contact-card-status',
    templateUrl: './bx-contact-card-status.component.html',
    standalone: false,
})
export class BxContactCardStatus {
    // @ts-ignore TS2564
    @Input() status: string;
    // @ts-ignore TS2564
    @Input() cardExpiryNextFriendly: string;
}

@NgModule({
    declarations: [BxContactCardStatus],
    imports: [CommonModule],
    exports: [BxContactCardStatus],
})
export class BxContactCardStatusModule {}
